export default __webpack_public_path__ + "static/media/logo-guest.1241525b.png";